import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _Icon404Color from './icon-404-color.vue';

const Icon404Color = Object.assign(_Icon404Color, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _Icon404Color.name, _Icon404Color);
  }
});

export default Icon404Color;
